module.exports = __webpack_public_path__ + "/images/landing-generalista-retallada.7ccbb83.webp";